module.exports = __webpack_public_path__ + "fonts/quicksand-v20-latin-500.8558600e.ttf";